import request from '@/http/request'

export const exportAccuracySummaryPage = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/accuracy/summary/exportAccuracySummary`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}
export const exportNoUpcMisMatchReport = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/accuracy/summary/noUpcMisMatchReport`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}

export const getAccuracySummaryQuery = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/accuracy/summary/queryAccuracySummary`,
    params
  )
}
